export const LoucasMetaisEAcessoriosIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.3033 3.59835C18.2322 5.06282 18.2322 7.43718 15.3033 8.90165C12.3744 10.3661 7.62562 10.3661 4.6967 8.90165C1.76777 7.43718 1.76777 5.06282 4.6967 3.59835C7.62563 2.13388 12.3744 2.13388 15.3033 3.59835"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.0832 11.2509C15.574 12.4134 12.9798 13.19 9.99984 13.19C7.01984 13.19 4.42567 12.4134 2.9165 11.2509"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.0832 14.7275C15.574 15.89 12.9798 16.6667 9.99984 16.6667C7.01984 16.6667 4.42567 15.89 2.9165 14.7275"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.95654 5.83333C7.60488 5.33417 8.71988 5 9.99988 5C11.2799 5 12.3949 5.33417 13.0432 5.83333"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
